export default __webpack_public_path__ + "static/media/est.74fd1f97.svg";